import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import AnimateIn from '@/atoms/AnimateIn'
import { ParagraphSM } from '@/atoms/Text'
import ContentfulImage from '@/molecules/ContentfulImage'
import { IContentBlockFields } from '@/types/generated-contentful'
import { Content, mapContent } from '@/utils/TorchGuildUtil'
import { getOptions } from './TextBlock'

interface Props {
  items?: Content[]
}

interface Testimonial extends IContentBlockFields {
  id: string
  contentType: 'contentBlock'
}

const TestimonialText: React.FC<{ text?: string }> = ({ text }) => {
  if (!text) return null

  return (
    <ParagraphSM color="core-gray-700" className="w-full text-center uppercase md:text-left">
      {text}
    </ParagraphSM>
  )
}

export const Testimonials = ({ items = [] }: Props) => {
  const testimonials = items.map(mapContent) as unknown as Testimonial[]

  return (
    <div className="flex flex-col gap-10">
      {testimonials.map(({ id, image, subtitle, text, title }) => (
        <AnimateIn
          key={id}
          variant="slideOver"
          className="flex w-full flex-col items-center gap-4 md:flex-row md:gap-8 md:even:flex-row-reverse"
        >
          {image && (
            <ContentfulImage
              image={image}
              className="object-cover md:rounded-md"
              containerClassName="flex-shrink-0 rounded-full w-[160px] h-[160px] overflow-hidden shadow-[0px_7px_10px_#C0C0C0] md:w-[262px] md:h-[262px] md:mb-0 md:rounded-none md:shadow-none"
              width={262}
              height={262}
              fit="fill"
              focus="face"
              lazy
            />
          )}
          <div>
            {text && (
              <div className="mb-2 text-center italic md:text-left">
                {documentToReactComponents(text, getOptions())}
              </div>
            )}
            <TestimonialText text={title} />
            {subtitle && <TestimonialText text={subtitle} />}
          </div>
        </AnimateIn>
      ))}
    </div>
  )
}

export default Testimonials
